'use stric'

import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Judges from '../app/getJudges';
import Interviewers from '../app/getInterviewers';
import '../styles/App.css';
import mainLogo from '../resources/main-logo.png';

class Home extends Component {

  render() {
    return (
      <div>
        <section className="section">
          <h1 className="homeTitleMain">FERIA DE OPORTUNIDADES</h1>
          <h1 className="homeTitle">¡LLAMADO A LA PARTICIPACIÓN!</h1>
          <Row className="descriptionRow">
            <div className="newspaper">
              <p className="descriptionParagraph">
              En el marco del Congreso COMPDES-2018, en la línea temática
              Emprendimientos y futuros profesionales en tecnologías,
              la Feria de Oportunidades llama a Ideas de negocios de software,
              hardware, producción audiovisual, multimedia y videojuegos a
              presentar su experiencia, su idea, su emprendimiento ante un grupo
              de expertos que por medio de foro provocarán un análisis de su
              idea y le darán una mayor aproximación a las oportunidades y
              mejoras que debe aplicar a su propuesta.</p>
              <p className="descriptionParagraph">
              Estudiantes con interés de conocer acerca del mercado tecnológico
              que desarrollan las empresas de TI de la Zona Norte, tipos de
              proyectos, dominios de aplicación y tecnologías en las que se
              enfocan esas empresas, clientes de las mismas, y otros aspectos.
              Así mismo, las empresas de tecnologías de información tendrán la
              oportunidad de conocer más de cerca la formación y el perfil de
              los profesionales de las universidades centroamericanas, con miras
              a que puedan desarrollar o identificar oportunidades de trabajo
              conjunto.</p>
              <p className="descriptionParagraph">
              Esta feria busca promover la interacción entre empresas, estudiantes
              y profesionales para: presentar ideas de emprendimientos tecnológicos
              para ser discutidas y retroalimentadas por expertos, proyectar a los
              nuevos profesionales en informática, dar a conocer sus perfiles y
              competencias, visibilizar las tendencias, necesidades y requerimientos
              del mercado laboral, así como facilitar procesos de intermediación
              laboral y realizar una aproximación a redes de emprendimiento como
              estrategia para la inclusión laboral y la promoción del desarrollo
              centroamericano.
              El objetivo de la feria es propiciar un espacio de encuentro entre
              empresarios de la Región Norte de Costa Rica con estudiantes de
              TIC de Centroamérica, con la finalidad de compartir oportunidades
              de emprendimientos, desarrollos y colaboración, generando sinergias
              centroamericanas entre los participantes.
               </p>
               <h2 className="homeTitle">Modalidades de participación</h2>
               <p className="descriptionParagraph">
               <a className="titledescriptionParagraph"> ◙ Entrevistas:</a> Los empresarios realizarán
                entrevistas con el fin de establecer
                y/o conocer su experiencia y conocimientos como posible
                colaborador o como posible empresario y, por supuesto, como
                persona. Los empresarios desean profundizar en temas laborales y
                empresariales, que les permita conocer más acerca de la
                formación del participante como futuro trabajador o empresario,
                y diferentes aspectos de relevancia que se deben tener en cuenta
                al elegir un colaborador o un socio.
                Los interesados podrán programar su entrevista en aplicación en
                línea según la disponibilidad de cada empresa.
                Cada entrevista tendrá una duración aproximada de 15 minutos.
              </p>
              <p className="descriptionParagraph">
                <a className="titledescriptionParagraph"> ◙ Presentación de idea de negocios:</a> Una presentación
                estructurada de una idea de negocios que se desea emprender,
                donde hay un alto grado de participación e interacción con
                expertos en la materia que les estarán dando retroalimentación
                acerca de sus ideas y las oportunidades reales que podrían tener
                con las mismas. Esta experiencia les permitirá desarrollar y
                mejorar técnicas, habilidades y/o competencias profesionales.
                Los interesados deben enviar su idea en el formato que se indica
                en la aplicación XXX y recibirán posteriormente la indicación de
                la hora en que estará programada su exposición. Cada
                presentación y análisis con expertos tendrá una duración
                aproximada de 15 minutos. Por cada idea el proponente o un
                miembro del equipo proponente deben presentar en 5 minutos
                usando una presentación su idea y en los siguientes 10 minutos
                un equipo de expertos conformado por tres personas les realizará
                una serie de preguntas de análisis y retroalimentación sobre su idea.
              </p>
            </div>
          </Row>
        </section>
        <section className="imageSection">
          <img src={mainLogo} className="imageSection"/>
        </section>
      </div>
    )
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home/home.js